import React from "react";
import "./Tournament.css";
import Header from "./Header";
import AddTournamentForm from "./AddTournamentForm";
export default function AddTournament() {
  return (
    <section className="addTournament">
      <Header />
      <AddTournamentForm />
    </section>
  );
}
